import React from 'react'
import PropTypes from 'prop-types'

import { DocumentFile } from '../../../entities/DocumentFile'

import './DocumentAsset.css'

const DocumentAsset = ({ asset, dark }) => {
    const { displayText } = asset

    const colorClass = dark ? 'darken' : ''
    const assetIcon = asset.getIcon(dark)

    return (
        <a
            href={asset.documentUrl}
            className={`document-asset document-asset--${colorClass}`}
            target="_blank"
            rel="noopener noreferrer"
        >
            {assetIcon && <img src={`${assetIcon}`} className="document-asset__icon" alt="asset" />}
            <div className={`document-asset__title ${colorClass}`}>
                <span>{displayText}</span>
            </div>
        </a>
    )
}

DocumentAsset.propTypes = {
    asset: PropTypes.instanceOf(DocumentFile).isRequired,
    dark: PropTypes.bool
}

DocumentAsset.defaultProps = {
    dark: false
}

export { DocumentAsset }
